import React,{useState,useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import { Button,Table,Container,Row,Col,Form } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';

function Master_State_List(){  
    const navigate = useNavigate();
    const [isMsgBox,setMsgBox] = useState(false); 
    const [msgText,setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [stateData, setStateData] = useState([]);

    const [showAddNewBtn,setShowAddNewBtn] = useState(true);
    const [showAddEditForm,setAddEditFormShow] = useState(false);
    const [srNo,setSrNo] = useState(0);
    const [state,setState] = useState("");

    const [status,setStatus] = useState(0);
    const [ddActiveOptions,setDdActiveOptions] = useState([]);

    const [country,setCountry] = useState(0);
    const [ddCountryOptions,setDdCountryOptions] = useState([]);

    const [filterActive,setFilterActive] = useState(0);
    const [ddFilterActiveOptions,setDdFilterActiveOptions] = useState([]);

    const [userRight,setUserRight] = useState([]);

    useEffect(()=>{
        if(onceRun){
            return;
        }else{
            setDdActiveOptions([{name:'Active',value:"1"},{name:'Inactive',value:"0"}]);
            Common.callApi(Common.apiCountry,[sid,'ddlistjson'],function(result){ 
                setDdCountryOptions(JSON.parse(result));
                setDdFilterActiveOptions(JSON.parse(result));
                setFilterActive(0);
               /* Common.callApi(Common.apiState,[sid,'listjson',1],function(result){ 
                    setStateData(JSON.parse(result));
                });*/
            });
            Common.callApi(Common.apiRight,[sid,'all','STATE'],function(result){
                let resp = JSON.parse(result);
                if(resp.query==="1"){
                    setUserRight(resp);
                }else{
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    },[onceRun,sid,navigate]);

    function getList(id){
        setFilterActive(id);
        Common.callApi(Common.apiState,[sid,'listjson',id],function(result){ 
            setStateData(JSON.parse(result));
        });
    }

    function refreshList(id){
        setFilterActive(id);
        getList(id);
    }
    
    function addNew(){
        setSrNo(0);
        setStatus(1);
        setState("");
        setCountry(0);
        setAddEditFormShow(true);
        setShowAddNewBtn(false); 
    }

    function saveData(){
        if(state==="" || country===0){
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {
            var object1 = {
                srno: srNo,
                state: state,
                cnt: country,
                act: status
            };
            Common.callApi(Common.apiState,[sid,'save',srNo,JSON.stringify(object1)],function(result){ 
                let resp = JSON.parse(result);
                if(resp.err===""){
                    setAddEditFormShow(false);
                    setShowAddNewBtn(true);
                    getList(filterActive);
                }else{
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        }
    }

    function cancelData(){
        setAddEditFormShow(false);
        setShowAddNewBtn(true);
    }

    function fillEditForm(id){
        Common.callApi(Common.apiState,[sid,'detail',id],function(result){ 
            let resp = JSON.parse(result);
            setSrNo(resp.srno);
            setState(resp.state);
            setCountry(resp.countrysrno);
            setStatus(resp.active);

            setAddEditFormShow(true);
            setShowAddNewBtn(false); 
        });
    }

    return(
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>State Master </h1>
                    </Col>  
                </Row>
                {showAddNewBtn?
                    <Row>
                        <Col>
                            {userRight.add==="1"?
                                <Button  variant="outline-primary" size="sm"  onClick={addNew}>Add New</Button>                
                            :null}
                        </Col>
                    </Row>
                :null
                }
                <Row><Col>&nbsp;</Col></Row>
                {showAddEditForm?
                    <Row>
                        <Col className="divContentCenter">
                            <div className="maxFormWidth">
                                <Form>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Serial Number</Form.Label>
                                                <Form.Control type="text" placeholder="Serial Number" value={srNo} disabled />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>State<span className="mandatory">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="State" maxLength={50}
                                                 value={state} onChange={(e)=>setState(e.target.value)}  autoComplete="off"/>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Country<span className="mandatory">*</span></Form.Label>
                                                <Form.Select 
                                                    value={country}
                                                    onChange={(e)=>setCountry(e.target.value)}
                                                    >
                                                    {ddCountryOptions.map((res)=>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>                                            
                                        </Col>
                                        <Col>                                        
                                            <Form.Group>
                                                <Form.Label>Status</Form.Label>
                                                <Form.Select  
                                                    value={status}
                                                    onChange={(e)=>setStatus(e.target.value)}
                                                    >
                                                    {ddActiveOptions.map((res)=>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row>
                                        <Col>
                                            <Button  variant="outline-success" size="sm"  onClick={()=>saveData()}>Save</Button>&nbsp;
                                            <Button  variant="outline-danger" size="sm"  onClick={()=>cancelData()}>Cancel</Button>
                                        </Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                :
                <>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Select  
                                    value={filterActive}
                                    onChange={(e)=>refreshList(e.target.value)}>
                                    {ddFilterActiveOptions.map((res)=>
                                        <option key={res.value} value={res.value}>{res.name}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>&nbsp;</Col>
                        <Col>&nbsp;</Col>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row><Col>&nbsp;</Col></Row>
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        {userRight.edit==="1"? <th></th> :null}
                                        <th className="textRight">Sr No</th>
                                        <th>State</th>
                                        <th>Country</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {stateData.map((res) =>
                                        <tr key={res.state_id}>
                                            {userRight.edit==="1"?
                                                <td className="textCenter" >
                                                    <span className="handCursor" onClick={()=>fillEditForm(res.state_id) } >
                                                        <div className="colorThemeBlue"><FontAwesomeIcon icon={faEdit}  /></div>
                                                    </span>
                                                </td>
                                                :null
                                            }
                                            <td className="textRight">{res.state_id}</td>
                                            <td>{res.state_name}</td>
                                            <td>{res.cnt_name}</td>
                                            <td>{res.state_active}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </>
                }
            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e)=> setMsgBox(false) }>
                    {msgText}
                </Dialog>
            </div>
        </>
    );
}
export default Master_State_List; 